import React from "react";
import { Link } from "react-router-dom";
import { NIVILABS_LOGO, BIONIVID_LOGO } from "@/lib/api";
import { Mail, Phone, MapPin , Instagram, Youtube, Linkedin} from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 bg-green-600" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-5 gap-10">
        <div>
          <div className="flex items-center">
            <img src={NIVILABS_LOGO} alt="nivilabs — a product of Bionivid" className="h-16 w-auto object-contain" />
          </div>
          <p className="mt-4 text-sm text-green-50 leading-relaxed">
            A premium laboratory solutions for consumables, reagents, enzymes,
            kits and research products — engineered for reproducibility.
          </p>
          <p className="mt-4 text-sm text-green-50 leading-relaxed">
            GSTIN: 29AAECB6049H1ZI
          </p>
          <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full hover:bg-white/30 transition-colors">
            <img src={BIONIVID_LOGO} alt="Bionivid" className="h-5 w-5 object-contain" />
            <a
              href="https://bionivid.in/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="bionivid-link-footer"
              className="text-xs text-green-50 hover:text-white font-medium"
            >
              Powered by Bionivid Technology Pvt. Ltd. ↗
            </a>
          </div>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3">Browse</h4>
          <ul className="space-y-2 text-sm text-green-50">
            <li><Link to="/products?category=enzymes" className="hover:text-white">Enzymes</Link></li>
            <li><Link to="/products?category=reagents" className="hover:text-white">Reagents</Link></li>
            <li><Link to="/products?category=kits" className="hover:text-white">Kits</Link></li>
            <li><Link to="/products?category=consumables" className="hover:text-white">Consumables</Link></li>
            <li><Link to="/products?category=instruments" className="hover:text-white">Instruments</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-green-50">
            <li><Link to="/about" className="hover:text-white">About nivilabs</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/login" className="hover:text-white">Customer Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3">Contact</h4>
          <ul className="space-y-3 text-sm text-green-50">
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-white" /> nivilabs@bionivid.com</li>
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-white" /> +91 953 5619 191</li>
            <li className="flex items-start gap-2"><MapPin className="w-8 h-8 m-0 text-white" /> 3rd Floor, Saanvi Complex, 28, Kattigenahalli, Bengaluru, Karnataka 560064</li>
<li className="flex items-start gap-2 w-full">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1103.5274957231109!2d77.62910818323918!3d13.120606438300564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae112d7040469b%3A0x7fb9e08b6e52b348!2sBionivid%20Technology%20Private%20Limited!5e0!3m2!1sen!2sin!4v1781158072056!5m2!1sen!2sin"
    className="w-full h-30 rounded-lg"
    style={{ border: 0 }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Bionivid Technology Location"
  />
</li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-3">Social</h4>
          <ul className="space-y-3 text-sm text-green-50">
            <li className="flex items-start gap-2"><a href="https://www.linkedin.com/company/bionivid-technology/" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Linkedin className="w-4 h-4 mt-0.5 text-white" /> LinkedIn</a></li>
            <li className="flex items-start gap-2"><a href="https://www.youtube.com/@bionivid_technology" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Youtube className="w-4 h-4 mt-0.5 text-white" /> Youtube</a></li>
            <li className="flex items-start gap-2"><a href="https://www.instagram.com/bionividtechnology/" target="_blank" rel="noopener noreferrer" className="hover:text-white"><Instagram className="w-4 h-4 mt-0.5 text-white" /> @Instagram</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-green-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center justify-between text-xs text-green-100">
          <span>© {new Date().getFullYear()} nivilabs — a product of{" "}
            <a href="https://bionivid.in/" target="_blank" rel="noopener noreferrer"
               className="font-semibold text-white hover:text-green-50 underline-offset-2 hover:underline"
               data-testid="bionivid-link-copyright">
              Bionivid Technology Pvt. Ltd. ↗
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
